import { render, staticRenderFns } from "./WorkFlow.vue?vue&type=template&id=f3d8afee&scoped=true&"
import script from "./WorkFlow.vue?vue&type=script&lang=js&"
export * from "./WorkFlow.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlow.vue?vue&type=style&index=0&id=f3d8afee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d8afee",
  null
  
)

export default component.exports